import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LandingpageComponent} from './landingpage.component';
import {Routes, RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {TranslateModule} from 'ng2-translate';
import {SelectModule} from 'angular2-select';
import {FormsModule} from '@angular/forms';
import {LandingpageResource} from './landingpage.resource';
import {ToastModule} from 'ng2-toastr/ng2-toastr';

export const routes: Routes = [
  {
    path: 'lp', children: [
      {path: '', pathMatch: 'full', component: LandingpageComponent},
      {path: 'DE/:token', component: LandingpageComponent},
      {path: 'de/:token', component: LandingpageComponent},
      {path: ':token', component: LandingpageComponent},
    ]
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule.forChild(routes),
    TranslateModule,
    SelectModule,
    ToastModule
  ],
  exports: [
    RouterModule,
    FormsModule,
    TranslateModule,
    SelectModule,
    ToastModule
  ],
  declarations: [
    LandingpageComponent
  ],
  providers: [
    LandingpageResource
  ],
  bootstrap: [
    LandingpageComponent
  ]
})
export class LandingpageModule {
}



// WEBPACK FOOTER //
// ./src/app/landingpage/landingpage.module.ts